var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 35,
    viewBox: "0 0 47 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 4.64455C47 4.3128 47 3.81517 46.837 3.48341C46.1852 1.49289 44.3926 0 42.1112 0H4.9563C2.83782 0 1.04526 1.49289 0.230458 3.48341C0.0674983 3.81517 -0.0954593 4.3128 0.0675008 4.64455C0.0675008 4.81043 0.0675008 4.81043 0.0675008 4.9763V30.0237C0.0675008 32.8436 2.34894 35 4.9563 35H42.1112C44.8815 35 47 32.6777 47 30.0237V4.9763C47 4.9763 47 4.81043 47 4.64455ZM42.1112 3.31754C42.6001 3.31754 42.926 3.48341 43.2519 3.81517L24.6745 16.09C24.0226 16.5877 23.2078 16.5877 22.556 16.09L3.81558 3.81517C4.1415 3.48341 4.46742 3.31754 4.9563 3.31754H42.1112ZM42.1112 31.6825H4.9563C3.97854 31.6825 3.3267 30.8531 3.3267 30.0237V7.46446L20.6005 18.7441C21.4153 19.2417 22.393 19.5735 23.5337 19.5735C24.5115 19.5735 25.4893 19.2417 26.467 18.7441L43.9038 7.29858V30.0237C43.7408 31.019 42.926 31.6825 42.1112 31.6825Z",
    fill: "#0CB56C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.5149900d660ec94d995f0c18dfd539a8.svg";
export { ForwardRef as ReactComponent };